<template>
  <admin-wrapper
    :straight-title="additionalModuleName"
    :is-form-fetched="isFormFetched"
    :moduleEnabler="moduleEnabler"
    :inputs="inputs"
    :has-buttons="false"
  >
    <template #greyTabs.input>
      <grey-tabs v-model="tab" :tabs="tabs" cols="auto" has-border>
        <v-tab-item v-for="item in tabs" :key="item.name">
          <component :is="item.component" :is-module-enabled="isModuleEnabled" />
        </v-tab-item>
      </grey-tabs>
    </template>
  </admin-wrapper>
</template>

<script>
import { call, get } from 'vuex-pathify';

import AdminWrapper from '@/components/AdminWrapper';
import GreyTabs from '@/components/GreyTabs';
import ScadaThreeTabData from '@/components/ScadaThreeTabData';
import ScadaThreeTabAttributes from '@/components/ScadaThreeTabAttributes';

export default {
  name: 'ScadaThreeSettings',
  components: {
    AdminWrapper,
    GreyTabs,
    ScadaThreeTabData,
    ScadaThreeTabAttributes,
  },
  data: () => ({
    isFormFetched: false,
    tab: 0,
  }),
  computed: {
    additionalModuleName: get('admin/additionalModules.SCADA3.verbose_name'),
    isModuleEnabled: get('admin/settingsValues@scada_3_module_enabled'),
    moduleEnabler() {
      return {
        name: 'scada_3_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
    inputs() {
      return [
        {
          name: 'greyTabs',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    tabs() {
      return [
        {
          name: this.$i18n.t('admin.scadaTabData'),
          component: 'ScadaThreeTabData',
        },
        {
          name: this.$i18n.t('admin.scadaTabAttributes'),
          component: 'ScadaThreeTabAttributes',
        },
      ];
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
  methods: {
    getDataSources: call('layers/getLayersMetadata'),
    getModulesMapping: call('admin/getModulesMapping'),
    async init() {
      this.isFormFetched = false;
      await Promise.all([this.getModulesMapping(), this.getDataSources({ with_attributes_schema: true })]);
      this.isFormFetched = true;
    },
  },
};
</script>
